import React, { useState } from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./LandingPage.scss";

import { Field } from "@randajan/jet-react/dom/form";



export const LandingPage = (props)=>{
    const [ color, setColor ] = useState();

    return (
        <Block level={0} className="LandingPage">
        </Block>
    )
}
